import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import StatsSection from "./components/StatsSection";
import CTASection from "./components/CTASection";
import ArticlePreview from "./components/ArticlePreview";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://pandabuy.cv";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "PandabuySpreadsheet",
  url: siteUrl,
  description: "The #1 Curated Pandabuy Spreadsheet Finder for fashion, sneakers, accessories, and budget finds. Discover trending items, compare quality, and explore curated shopping spreadsheets updated daily for 2026.",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${siteUrl}/search?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <StatsSection />
        <CTASection />
        <ArticlePreview />
      </main>
      <Footer />
    </div>
  );
}